module.exports = __webpack_public_path__ + "fonts/cn.11c302dd.OTF";